import React from 'react';
import { Heart, Award, Users } from 'lucide-react';
import { aboutInfo } from '../data/mock';

const About = () => {
  const features = [
    {
      icon: Heart,
      title: 'Amor y Empatía',
      description: 'Tratamos a cada mascota con el amor y cuidado que merece, como si fuera nuestra propia familia.'
    },
    {
      icon: Award,
      title: 'Profesionalismo',
      description: 'Contamos con la experiencia y conocimientos necesarios para brindar el mejor cuidado veterinario.'
    },
    {
      icon: Users,
      title: 'Atención Personalizada',
      description: 'Cada mascota es única y recibe un plan de cuidado diseñado especialmente para sus necesidades.'
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Sobre Nosotros</span>
              <div className="h-1 w-20 bg-teal-500 mt-2 rounded-full"></div>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Tu mascota en las mejores manos
            </h2>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              {aboutInfo.description}
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              {aboutInfo.mission}
            </p>

            <div className="pt-6 border-t border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Nuestro Equipo</h3>
              <p className="text-gray-600 leading-relaxed">
                {aboutInfo.team}
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_pawsome-care-53/artifacts/ag26juzb_Nosotros_Patas_Club.png"
                alt="Veterinaria Genesis de Patas Club"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-teal-100 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-rose-100 rounded-full -z-10"></div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mt-20">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-6 bg-gradient-to-br from-teal-50 to-white rounded-xl border border-teal-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;